import mixpanel from 'mixpanel-browser'
const enableMixpanel =
  import.meta.env.VITE_SPA_OSPREY_ENABLE_MIXPANEL === true || import.meta.env.VITE_SPA_OSPREY_ENABLE_MIXPANEL === 'true'

let testMode = false

export const setTestMode = (mode) => {
  testMode = mode
}

export const mixpanelInit = () => {
  if (testMode || !enableMixpanel) return

  mixpanel.init(import.meta.env.VITE_SPA_OSPREY_MIXPANEL_TOKEN, {
    debug: import.meta.env.PROD === false, // only enable debug in non-production environments
    track_pageview: false, // we need to do this manually as we use the hashrouter, and so we can log routeId without params
    persistence: 'localStorage',
    ignore_dnt: true
  })
}

export const mixpanelIdentifyUser = ({ userId, companyCode, databaseSuffix, emailAddress, roleId, isSupervisor }) => {
  if (testMode || !enableMixpanel) return

  mixpanel.identify(userId)

  mixpanel.people.set({
    $email: emailAddress,
    companyCode,
    databaseSuffix,
    environment: import.meta.env.PROD ? 'production' : 'development',
    roleId,
    isSupervisor
  })
}

export const mixpanelTrackPageView = (page, urlSegments, iframeSrc, menuItemId) => {
  if (testMode || !enableMixpanel) return

  const params = { current_url_path: page, Osprey1Page: iframeSrc }

  const [urlSegment1, urlSegment2, urlSegment3] = urlSegments
  if (urlSegment1) params.URLSegment1 = urlSegment1
  if (urlSegment2) params.URLSegment2 = urlSegment2
  if (urlSegment3) params.URLSegment3 = urlSegment3

  if (menuItemId) params.menuItemId = menuItemId

  mixpanel.track_pageview(params)
}

export const mixpanelUnidentifyUser = () => {
  if (testMode || !enableMixpanel) return

  mixpanel.reset()
}

export const mixpanelTrackUserEvent = (eventName, eventProperties) => {
  if (testMode || !enableMixpanel) return

  mixpanel.track(eventName, eventProperties)
}

export default mixpanel
